module.exports = __webpack_public_path__ + "assets/je-orange-lg-logo-a23d5e.svg";